module.exports = __webpack_public_path__ + "static/media/li.3719ea6d.svg";